import { render, staticRenderFns } from "./mbedit.vue?vue&type=template&id=70d7b91b&scoped=true&"
import script from "./mbedit.vue?vue&type=script&lang=js&"
export * from "./mbedit.vue?vue&type=script&lang=js&"
import style0 from "./mbedit.vue?vue&type=style&index=0&id=70d7b91b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d7b91b",
  null
  
)

export default component.exports